import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getScheduleCommentaryUpdates = api(async function getScheduleCommentaryUpdates() {
    return query(
        gql`
            query GetScheduleCommentaryUpdates {
                getScheduleCommentaryUpdates {
                    category
                    schedules {
                        id
                        status
                        excludedFromCycle
                        scheduleId
                        scheduleVersion
                        scheduleTitle
                        scheduleCode
                        category
                        originalCategory
                        groupCategory
                        sections {
                            amendsKey
                            label
                            content
                            hasAmends
                        }
                        legislation {
                            scheduleLegislationId
                            html
                            url
                        }
                        readyToPublish
                    }
                }
            }
        `,
        {},
        { returns: "getScheduleCommentaryUpdates" }
    )
})
